import { gql } from '@/__generated__/gql';

export const GET_FUNNEL_QUERY = gql(`
  query SettingsPageGetDueDiligenceFunnel($id: String!) {
    getDueDiligenceFunnel(id: $id) {
      id
      funnelStaticId
      name
      externalId
      status
      docxTemplateStorageKey
      records {
        id
        investment {
          securityStatus
        }
      }
      tiers {
        id
        name
        order
        sections {
          id
          name
          userCanScore
          pdfLayout
          order
          fields {
            id
            name
            type
            order
            required
            linkedFieldId
            linkedField {
              id
              name
              funnelTierSection {
                name
                funnelTier {
                  name
                }
              }
            }
            promptGroup {
              id
              prompts
              summaryPrompt
              contextPrompt
              rubricTemplates
              outputStructure
              useCustomContextPrompt
              useCustomSummaryPrompt
            }
          }
        }
        checklistItems {
          id
          name
          order
          required
        }
      }
    }
  }
`);

export const DUE_DILIGENCE_FUNNEL_LIST_SETTINGS_QUERY = gql(`
  query SettingsPageListDueDiligenceFunnels($data: DueDiligenceFunnelListDto!, $archivedFunnelData: DueDiligenceFunnelListByStatusDto!) {
    listDueDiligenceFunnels(data: $data) {
      id
      funnelStaticId
      externalId
      name
      createdAt
      status
      records {
        id
        investment {
          id
          name
          securityStatus
        }
      }
      draftFunnel {
        id
        createdAt
        name
      }
      archivedFunnels(data: $archivedFunnelData) {
        records {
          investment {
            securityStatus
          }
        }
      }
    }
  }
`);

export const DELETE_DUE_DILIGENCE_FUNNEL_MUTATION = gql(`
  mutation SettingsPageDeleteDueDiligenceFunnel($id: String!) {
    deleteDueDiligenceFunnel(id: $id)
  }
`);

export const CREATE_DUE_DILIGENCE_FUNNEL_MUTATION = gql(`
  mutation SettingsPageCreateDueDiligenceFunnel($data: DueDiligenceFunnelCreateDto!) {
    createDueDiligenceFunnel(data: $data) {
      id
      name
    }
  }
`);

export const COPY_DUE_DILIGENCE_FUNNEL_MUTATION = gql(`
  mutation SettingsPageCopyDueDiligenceFunnel($data: DueDiligenceFunnelCopyDto!) {
    copyDueDiligenceFunnel(data: $data) {
      id
      name
    }
  }
`);

export const UPDATE_DUE_DILIGENCE_FUNNEL_MUTATION = gql(`
  mutation SettingsPageUpdateDueDiligenceFunnel($data: DueDiligenceFunnelUpdateDto!) {
    updateDueDiligenceFunnel(data: $data) {
      id
      name
    }
  }
`);

export const UPDATE_DUE_DILIGENCE_FUNNEL_ORDER_MUTATION = gql(`
  mutation SettingsPageUpdateDueDiligenceFunnelsOrder($data: [DueDiligenceFunnelUpdateOrderDto!]!) {
    updateDueDiligenceFunnelsOrder(data: $data) {
      id
    }
  }
`);

export const CREATE_DUE_DILIGENCE_TIER_MUTATION = gql(`
  mutation SettingsPageCreateDueDiligenceFunnelTier($data: DueDiligenceFunnelTierCreateDto!) {
    createDueDiligenceFunnelTier(data: $data) {
      id
      name
      order
    }
  }
`);

export const UPDATE_DUE_DILIGENCE_TIER_MUTATION = gql(`
  mutation SettingsPageUpdateDueDiligenceFunnelTier($data: DueDiligenceFunnelTierUpdateDto!) {
    updateDueDiligenceFunnelTier(data: $data) {
      id
      name
      order
    }
  }
`);

export const UPDATE_DRAFT_DUE_DILIGENCE_TIER_MUTATION = gql(`
  mutation SettingsPageUpdateDraftDueDiligenceFunnelTier($data: DraftDueDiligenceFunnelTierUpdateDto!) {
    updateDraftDueDiligenceFunnelTier(data: $data) {
      id
      name
    }
  }
`);

export const CREATE_DUE_DILIGENCE_SECTION_MUTATION = gql(`
  mutation SettingsPageCreateDueDiligenceFunnelTierSection($data: DueDiligenceFunnelTierSectionCreateDto!) {
    createDueDiligenceFunnelTierSection(data: $data) {
      id
      name
      order
      userCanScore
      pdfLayout
    }
  }
`);

export const UPDATE_DUE_DILIGENCE_SECTION_MUTATION = gql(`
  mutation SettingsPageUpdateDueDiligenceFunnelTierSection($data: DueDiligenceFunnelTierSectionUpdateDto!) {
    updateDueDiligenceFunnelTierSection(data: $data) {
      id
      name
      order
      userCanScore
      pdfLayout
    }
  }
`);

export const UPDATE_DRAFT_DUE_DILIGENCE_SECTION_MUTATION = gql(`
  mutation SettingsPageUpdateDraftDueDiligenceFunnelTierSection($data: DraftDueDiligenceFunnelTierSectionUpdateDto!) {
    updateDraftDueDiligenceFunnelTierSection(data: $data) {
      id
      name
      userCanScore
      pdfLayout
    }
  }
`);

export const CREATE_DUE_DILIGENCE_FIELD_MUTATION = gql(`
  mutation SettingsPageCreateDueDiligenceFunnelTierSectionField($data: DueDiligenceFunnelTierSectionFieldCreateDto!) {
    createDueDiligenceFunnelTierSectionField(data: $data) {
      id
      name
      linkedFieldId
    }
  }
`);

export const UPDATE_DUE_DILIGENCE_FIELD_MUTATION = gql(`
  mutation SettingsPageUpdateDueDiligenceFunnelTierSectionField($data: DueDiligenceFunnelTierSectionFieldUpdateDto!) {
    updateDueDiligenceFunnelTierSectionField(data: $data) {
      id
    }
  }
`);

export const UPDATE_DRAFT_DUE_DILIGENCE_FIELD_MUTATION = gql(`
  mutation SettingsPageUpdateDraftDueDiligenceFunnelTierSectionField($data: DraftDueDiligenceFunnelTierSectionFieldUpdateDto!) {
    updateDraftDueDiligenceFunnelTierSectionField(data: $data) {
      id
    }
  }
`);

export const CREATE_DUE_DILIGENCE_CHECKLIST_ITEM_MUTATION = gql(`
  mutation SettingsPageCreateDueDiligenceFunnelTierChecklistItem($data: DueDiligenceFunnelTierChecklistItemCreateDto!) {
    createDueDiligenceFunnelTierChecklistItem(data: $data) {
      id
      name
      order
      required
    }
  }
`);

export const UPDATE_DUE_DILIGENCE_CHECKLIST_ITEM_MUTATION = gql(`
  mutation SettingsPageUpdateDueDiligenceFunnelTierChecklistItem($data: DueDiligenceFunnelTierChecklistItemUpdateDto!) {
    updateDueDiligenceFunnelTierChecklistItem(data: $data) {
      id
      name
      order
      required
    }
  }
`);

export const UPDATE_DRAFT_DUE_DILIGENCE_CHECKLIST_ITEM_MUTATION = gql(`
  mutation SettingsPageUpdateDraftDueDiligenceFunnelTierChecklistItem($data: DraftDueDiligenceFunnelTierChecklistItemUpdateDto!) {
    updateDraftDueDiligenceFunnelTierChecklistItem(data: $data) {
      id
      name
      required
    }
  }
`);

export const DELETE_DUE_DILIGENCE_TIER_MUTATION = gql(`
  mutation SettingsPageDeleteDueDiligenceFunnelTier($id: String!) {
    deleteDueDiligenceFunnelTier(id: $id)
  }
`);

export const DELETE_DUE_DILIGENCE_SECTION_MUTATION = gql(`
  mutation SettingsPageDeleteDueDiligenceFunnelTierSection($id: String!) {
    deleteDueDiligenceFunnelTierSection(id: $id)
  }
`);

export const DELETE_DUE_DILIGENCE_FIELD_MUTATION = gql(`
  mutation SettingsPageDeleteDueDiligenceFunnelTierSectionField($id: String!) {
    deleteDueDiligenceFunnelTierSectionField(id: $id)
  }
`);

export const DELETE_DUE_DILIGENCE_CHECKLIST_ITEM_MUTATION = gql(`
  mutation SettingsPageDeleteDueDiligenceFunnelTierChecklistItem($id: String!) {
    deleteDueDiligenceFunnelTierChecklistItem(id: $id)
  }
`);
